import url from '../url'
import headers from '../headers'

export default {
	getListAll (context, user_uid, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/completed/?size=${size}`,
			headers.bearer()
		)
	},
	getAll (context, user_uid, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/?size=${size}`,
			headers.bearer()
		)
	},
	get (context, user_uid, watch_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/`,
			headers.bearer()
		)
	},
	add (context, user_uid, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/watches/`,
			model,
			headers.bearer()
		)
	},
	devices: {
		getAll (context, user_uid, watch_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/watches/${watch_id}/devices/`,
				headers.bearer()
			)
		},
		attach (context, user_uid, watch_id, model) {
			return context.$http.post(
				`${url}/users/${user_uid}/watches/${watch_id}/devices/`,
				model,
				headers.bearer()
			)
		},
		detach (context, user_uid, watch_id, device_id) {
			return context.$http.delete(
				`${url}/users/${user_uid}/watches/${watch_id}/devices/${device_id}/`,
				headers.bearer()
			)
		}
	},
	configurations: {
		get (context, user_uid, watch_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/watches/${watch_id}/configurations/`,
				headers.bearer()
			)
		},
		edit (context, user_uid, watch_id, model) {
			return context.$http.put(
				`${url}/users/${user_uid}/watches/${watch_id}/configurations/`,
				model,
				headers.bearer()
			)
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/patients.js